import React, { useCallback } from 'react'
import { DotButton, useDotButton } from './emblaCarouselDotButton'
import { PrevButton, NextButton, usePrevNextButtons } from './emblaCarouselArrowButtons'
import Autoplay from 'embla-carousel-autoplay'
import AutoScroll from 'embla-carousel-auto-scroll'
import useEmblaCarousel from 'embla-carousel-react'

const EmblaCarousel = (props) => {
  const { arrows = false, autoplay = false, autoplayDelay = 5000, autoScroll = false, children, className, direction = 'forward', dots = false, speed = 1, startDelay = 0, options } = props

  const plugins = [
    ...(autoplay ? [Autoplay({ delay: autoplayDelay })] : []),
    ...(autoScroll
      ? [
          AutoScroll({
            playOnInit: true,
            speed: speed,
            stopOnInteraction: false,
            direction: direction,
            startDelay: startDelay
          })
        ]
      : [])
  ]

  const [emblaRef, emblaApi] = useEmblaCarousel(options, plugins)

  const onNavButtonClick = useCallback((emblaApi) => {
    const autoplay = emblaApi?.plugins()?.autoplay
    if (!autoplay) return

    const resetOrStop = autoplay.options.stopOnInteraction === false ? autoplay.reset : autoplay.stop

    resetOrStop()
  }, [])

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi, onNavButtonClick)

  const { prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaApi, onNavButtonClick)

  return (
    <div className={`embla relative w-full${className ? ` ${className}` : ''}`}>
      <div className='relative'>
        <div className='overflow-hidden' ref={emblaRef}>
          <div className='flex w-full'>{children}</div>
        </div>
        {arrows && (
          <div className='flex gap-2 ml-2'>
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>
        )}
        <div className='flex text-center'>
          {dots && (
            <div className='mx-auto flex gap-1 md:gap-2 items-center p-1'>
              {scrollSnaps.map((_, index) => (
                <DotButton
                  key={index}
                  onClick={() => onDotButtonClick(index)}
                  className={`rounded-full w-4 h-4 ml-2 my-2 border border-transparent focus:outline-none focus:ring focus:ring-purple-500 embla__dot${index === selectedIndex ? ' is-selected bg-fuchsia-600 hover:text-white border-fuchsia-500' : ' border-fuchsia-500 bg-gray-200'}`}>
                  <span className='sr-only'>Select image {index + 1}</span>
                </DotButton>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default EmblaCarousel
